import { IFilter } from '../../types/filters';
import { LayoutContainer } from '../../containers/advancedFilters/LayoutContainer';

export const layout: IFilter = {
  component: LayoutContainer,
};
